import { AbstractRenderer } from '@blk/simba';
import { DEFAULT_GROSS_PERFORMANCE_DISCLOSURE, DEFAULT_PERFORMANCE_DISCLOSURE_TEXT_CLASSES } from '@ddt-web/pdf-utils';

import { DisclosureComponent } from '../../disclaimers/disclosure-component';

export class PerformanceDisclaimerUtil {

	public static customFeeEnabledDisclaimer(dcrKey: string) {
		const panel: AbstractRenderer<SVGGElement>[] = [];
		panel.push(
			new DisclosureComponent(
				dcrKey + `PREFIX`, dcrKey + `PREFIX`, {}, { paddingTop: 5, paddingBottom: 10 }, DEFAULT_PERFORMANCE_DISCLOSURE_TEXT_CLASSES
			),
			new DisclosureComponent(
				dcrKey + `BOX`, dcrKey + `BOX`, {},
				{
					borderTop: 0.5, borderLeft: 0.5, borderRight: 0.5, borderBottom: 0.5,
					paddingTop: 1, paddingLeft: 1, paddingRight: 1, paddingBottom: 1
				},
				DEFAULT_PERFORMANCE_DISCLOSURE_TEXT_CLASSES
			),
			new DisclosureComponent(
				dcrKey + `SUFFIX`, dcrKey + `SUFFIX`, {}, { paddingTop: 10, paddingBottom: 5 }, DEFAULT_PERFORMANCE_DISCLOSURE_TEXT_CLASSES
			)
		);
		return panel;
	}

	public static noCustomFeeEnabledDisclaimer(dcrKey: string, disclaimerTextClasses?: string[]): AbstractRenderer<SVGGElement> {
		return (
			new DisclosureComponent(
				dcrKey, DEFAULT_GROSS_PERFORMANCE_DISCLOSURE, {}, { paddingBottom: 5 }, disclaimerTextClasses
			)
		);
	}

	public static generatePerformanceFeeDisclaimer(dcrPrefix: string, customAdvisoryFee?: number, textClasses?: string[]): AbstractRenderer<SVGGElement> {
		if (customAdvisoryFee) {
			return new DisclosureComponent(
				dcrPrefix + 'NET_FEE_DISCLOSURE',
				'Net of {0}% advisory fee',
				{ 0: customAdvisoryFee },
				{},
				textClasses
			);
		} else {
			return new DisclosureComponent(dcrPrefix + 'GROSS_FEE_DISCLOSURE', 'Gross of an advisory fee', {}, {}, textClasses);
		}
	}
}
